/**
 * Design px → CSS length. 1 rem = 16 design px at the reference width (tokens.css scales the root font-size),
 * so rem lengths inside a `<Stage>` are divided back out by its transform: 1 design px = `stage.scale` CSS px.
 * Use it for values that come from documents (positions, user-chosen sizes); static sizes use Tailwind numbers.
 */
export const dp = (n: number) => `${n / 16}rem`;

export const clamp = (n: number, min: number, max: number) => Math.min(max, Math.max(min, n));
